import React, { Component } from 'react';
import Cabecalho from '../../componentes/Cabecalho';
import CabecalhoPainel from '../../componentes/CabecalhoPainel';
import { Redirect } from 'react-router-dom';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import CurrencyInput from 'react-currency-input';
import { base_url, api_key } from '../../config/config_api';

class OfertaAutos extends Component {

    constructor (props){
        super(props);

        this.state = {
            returnPagina: false,
            estaGravando: false,
            vefipe_combustivel: "",
            vecambio: "",
            vecarroceria: "",
            veveiculonovo: 2,
            veipva_pago: false,
            vevalor: 0,
            vevalor_mask: "",
            vequilometragem: "",
            cidade: "",
            uf: "",
            raio: "",
            ordenacao: "asc",
            limite: "10",
            usuarioLogado: JSON.parse(window.localStorage.getItem("usuarioLogado")),
        }

        this.mounted   = false;
        this.handleChange  = this.handleChange.bind(this);
        this.handleChangeValue  = this.handleChangeValue.bind(this);
        this.handleChangeKm  = this.handleChangeKm.bind(this);
        this.handleSubmit  = this.handleSubmit.bind(this);
        this.goBack        = this.goBack.bind(this);        
    }

    goBack(){
        this.props.history.goBack();
    }

    componentDidMount(){
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    handleChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        });
    }    

    handleChangeValue(event, maskedvalue, floatvalue){
        this.setState({
            vevalor: floatvalue,
            vevalor_mask: maskedvalue,
        });
    }

    handleChangeKm(event, maskedvalue, floatvalue){
        this.setState({
            vequilometragem: maskedvalue,
        });
    }


    handleSubmit(event) {

        this.setState({estaGravando: true});

        var veiculo = {    
            api_key: api_key,   
            cambio: this.state.vecambio,
            combustivel: this.state.vefipe_combustivel,
            veiculonovo: this.state.veveiculonovo === 2 ? "" : this.state.veveiculonovo.toString(),
            km: parseInt(this.state.veveiculonovo) === 1 ? "" : this.state.vequilometragem.toString(),
            carroceria: this.state.vecarroceria,
            valor_maximo: parseFloat(this.state.vevalor.toString()) > 0 ? this.state.vevalor.toString() : "",
            ipva_pago: this.state.veipva_pago === true ? "1" : "",
            cidade: this.state.cidade,
            uf: this.state.uf,
            raio: this.state.raio,  
            ordenacao: this.state.ordenacao,
            limite: this.state.limite,
        }   

        fetch(base_url + "/api/integracao/ofertaautos/exportar-xml", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(veiculo)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Erro ao exportar XML: ' + response.status);
            }
            return response.text(); // XML é texto, não JSON
        })
        .then(xmlText => {
            // Cria um blob com o conteúdo XML
            const blob = new Blob([xmlText], { type: 'application/xml' });

            // Cria um link temporário e dispara o download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'veiculos.xml');
            document.body.appendChild(link);
            link.click();

            // Limpa o link temporário
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            this.setState({ estaGravando: false });
        })
        .catch(error => {
            console.log(error);
            this.setState({ estaGravando: false });
        });

    }

    render(){
        const { 
            estaGravando, 
            vecambio,
            vefipe_combustivel,
            vequilometragem,
            vevalor_mask,
            veipva_pago,
            vecarroceria,
            veveiculonovo,
            cidade,
            uf,
            raio,
            ordenacao,
            limite
        } = this.state;
        if(this.state.returnPagina){
            var link = "/dashboard";
            return <Redirect to={link} />;
        }        

        if(this.state.usuarioLogado !== null && this.state.usuarioLogado.role !== 'admin'){
            return <Redirect to='/acesso-negado' />
        }
        
        return (
            <div>
                {
                    this.state.usuarioLogado !== null && this.state.usuarioLogado.role === 'admin' ? <Cabecalho /> :  <CabecalhoPainel />
                }
                <div id="page-wrapper">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="page-header">Exportar XML Oferta Autos</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    Exportar XML
                                </div>
                                <div className="panel-body form-veiculo">

                                    <ValidatorForm
                                        ref="form"
                                        onSubmit={this.handleSubmit}
                                    >
                                        
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label>Tipo veículo *</label><br/>
                                                    <label className="radio">
                                                        <input type="radio" name="veveiculonovo" value="1" onChange={this.handleChange} defaultChecked={veveiculonovo === 1 ? true : false} /> &nbsp;&nbsp;Novo (0km)
                                                    </label>
                                                    <label className="radio">
                                                        <input type="radio" name="veveiculonovo" value="0" onChange={this.handleChange} defaultChecked={veveiculonovo === 0 ? true : false} /> &nbsp;&nbsp;Seminovo
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label>Km Máxima</label><br/>  
                                                    <TextValidator
                                                        onChange={this.handleChange}
                                                        name="vequilometragem"
                                                        value={vequilometragem}
                                                        className="form-ui-bootstrap"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label>Preço Máximo</label><br/>    
                                                    <CurrencyInput 
                                                        onChangeEvent={this.handleChangeValue}
                                                        label="Preço *"
                                                        name="vevalor"
                                                        value={vevalor_mask}
                                                        className="form-ui-bootstrap"
                                                        decimalSeparator=","
                                                        thousandSeparator="."
                                                        precision="2"
                                                        prefix="R$ "
                                                    />
                                                </div>
                                            </div>                                    
                                        </div>
                                        <div className="row">  
                                            <div className="col-lg-3">
                                                <div className="form-group">
                                                    <label>Combustível</label>
                                                    <select className="form-ui-bootstrap" name="vefipe_combustivel" onChange={this.handleChange} value={ vefipe_combustivel }>
                                                        <option value="">Selecione</option>
                                                        <option value="flex">Flex</option>
                                                        <option value="alcool">Álcool</option>
                                                        <option value="gasolina">Gasolina</option>
                                                        <option value="diesel">Diesel</option>
                                                        <option value="gnv">GNV</option>
                                                        <option value="eletrico">Elétrico</option>
                                                        <option value="hibrido">Híbrido</option>
                                                        <option value="oleo">Óleo</option>
                                                    </select>
                                                </div>
                                            </div>       
                                            <div className="col-lg-3">
                                                <div className="form-group">
                                                    <label>Câmbio</label>
                                                    <select className="form-ui-bootstrap" name="vecambio" onChange={this.handleChange} value={ vecambio }>
                                                        <option value="">Selecione</option>
                                                        <option value="A">Automático</option>
                                                        <option value="M">Manual</option>
                                                    </select>
                                                </div>
                                            </div>     
                                            <div className="col-lg-3">
                                                <div className="form-group">
                                                    <label>Carroceria</label>
                                                    <select className="form-ui-bootstrap" name="vecarroceria" onChange={this.handleChange} value={ vecarroceria }>
                                                        <option value="">Selecione</option>
                                                        <option value="Sedan">Sedan</option>
                                                        <option value="Hatch">Hatch</option>
                                                        <option value="SUV">SUV</option>
                                                        <option value="Passeio">Passeio</option>
                                                        <option value="Conversível">Conversível</option>
                                                        <option value="Pick-up">Pick-up</option>
                                                        <option value="Antigo">Antigo</option>
                                                        <option value="Buggy">Buggy</option>
                                                        <option value="Van/Utilitário">Van/Utilitário</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <div className="form-group">
                                                    <label>Extra</label>
                                                    <p className="checkbox-item">
                                                        <label className="checkbox-label">
                                                            <input type="checkbox" name="veipva_pago" defaultChecked={veipva_pago} onChange={this.handleChange} /> 
                                                            &nbsp;&nbsp;IPVA Pago
                                                        </label>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label>Cidade</label><br/>  
                                                    <TextValidator
                                                        onChange={this.handleChange}
                                                        name="cidade"
                                                        value={cidade}
                                                        className="form-ui-bootstrap"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-2">
                                                <div className="form-group">
                                                    <label>UF</label>
                                                    <select className="form-ui-bootstrap" name="uf" onChange={this.handleChange} value={ uf }>
                                                        <option value="">Selecione</option>
                                                        <option value="AC">ACRE</option>
                                                        <option value="AL">ALAGOAS</option>
                                                        <option value="AP">AMAPA</option>
                                                        <option value="AM">AMAZONAS</option>
                                                        <option value="BA">BAHIA</option>
                                                        <option value="CE">CEARA</option>
                                                        <option value="DF">DISTRITO FEDERAL</option>
                                                        <option value="ES">ESPIRITO SANTO</option>
                                                        <option value="GO">GOIAS</option>
                                                        <option value="MA">MARANHAO</option>
                                                        <option value="MT">MATO GROSSO</option>
                                                        <option value="MS">MATO GROSSO DO SUL</option>
                                                        <option value="MG">MINAS GERAIS</option>
                                                        <option value="PA">PARA</option>
                                                        <option value="PB">PARAIBA</option>
                                                        <option value="PR">PARANA</option>
                                                        <option value="PE">PERNAMBUCO</option>
                                                        <option value="PI">PIAUI</option>
                                                        <option value="RJ">RIO DE JANEIRO</option>
                                                        <option value="RN">RIO GRANDE DO NORTE</option>
                                                        <option value="RS">RIO GRANDE DO SUL</option>
                                                        <option value="RO">RONDONIA</option>
                                                        <option value="RR">RORAIMA</option>
                                                        <option value="SC">SANTA CATARINA</option>
                                                        <option value="SP">SAO PAULO</option>
                                                        <option value="SE">SERGIPE</option>
                                                        <option value="TO">TOCANTINS</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-2">
                                                <div className="form-group">
                                                    <label>Raio (Km)</label>
                                                    <select className="form-ui-bootstrap" name="raio" onChange={this.handleChange} value={ raio }>
                                                        <option value="">Selecione</option>
                                                        <option value="50">50 km</option>
                                                        <option value="100">100 km</option>
                                                        <option value="200">200 km</option>
                                                        <option value="300">300 km</option>
                                                        <option value="500">500 km</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label>Ordenação (Data criação)</label>
                                                    <select className="form-ui-bootstrap" name="ordenacao" onChange={this.handleChange} value={ ordenacao }>
                                                        <option value="asc">Crescente</option>
                                                        <option value="desc">Decrescente</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label>Quantidade de veículos</label><br/>  
                                                    <TextValidator
                                                        onChange={this.handleChange}
                                                        name="limite"
                                                        value={limite}
                                                        className="form-ui-bootstrap"
                                                        validators={['minNumber:0', 'matchRegexp:^[0-9]{1,}$']}
                                                        errorMessages={['Quantidade inválida', 'Quantidade inválida']}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <button type="submit" variant="contained" color="primary" className="btn btn-primary" disabled={estaGravando} >Baixar XML</button> <button disabled={estaGravando} onClick={this.goBack} className="btn btn-warning" >Voltar</button>
                                            </div>
                                        </div>
                                    </ValidatorForm>                                    

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}

export default OfertaAutos